// test1221
(1221 && 0);
